import { api } from 'api'
import { path } from 'ramda'

export async function getWorkerCompliments(workerId: number) {
  const data = await api.post(
    '/company/graphql_dispatch/worker_compliments_6959ef79',
    {
      workerId,
    }
  )

  const workForWorkWhile =
    path(['data', 'data', 'company', 'worker', 'workForWorkWhile'], data) ?? []

  const compliments: Record<string, number> = {}
  workForWorkWhile.forEach((work) => {
    try {
      const tags: string[] = work.e2wReview.tags
        ? JSON.parse(work.e2wReview.tags)
        : []
      tags.forEach((tag) => {
        if (tag in compliments) {
          compliments[tag] += 1
        } else {
          compliments[tag] = 1
        }
      })
    } catch {
      // do nothing
    }
  })

  return compliments
}
